import { atom } from 'jotai';

import type { RegionAreaAtom } from './RegionAtom.entity';

export const areaAtomDefaultValue = {
  key: 'any_area',
  displayName: 'Any Area',
  region: 'anyarea',
  location: {
    lat: 0,
    lon: 0,
  },
  postcode: '',
  area: 'any_area',
};

export const areaAtom = atom<RegionAreaAtom>(areaAtomDefaultValue);
